export const UPDATE_CUSTOMER_AVATAR = "UPDATE_CUSTOMER_AVATAR"
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
export const DELETE_AD_IMAGE = "DELETE_AD_IMAGE"

export const updateCustomer = (customerId, params, success, error) => ({
  type: UPDATE_CUSTOMER,
  customerId,
  params,
  success,
  error,
})

export const updateCustomerAvatar = (params, success, error) => ({
  type: UPDATE_CUSTOMER_AVATAR,
  params,
  success,
  error,
})

// params: {imageType: 'adHomepageImg' | 'adBannerImg' }
export const deleteAdImage = (params, success, error) => ({
  type: DELETE_AD_IMAGE,
  params,
  success,
  error,
})
